import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import LoadingSpinner from '../components/LoadingSpinner'

const MaterialAdvice = lazy(
  async () => import('@/pages/getRecipe/fullMonolithic/materialAdvice'),
)
const Staining = lazy(
  async () => import('@/pages/getRecipe/fullMonolithic/staining'),
)

const FullMonolithicRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="material-advice" element={<MaterialAdvice />} />
        <Route path="staining" element={<Staining />} />
      </Routes>
    </Suspense>
  )
}

export default FullMonolithicRoutes
